import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import PropType from 'prop-types';
import { InputAdornment } from '@mui/material';
import NInput from './NInput';

function NSearch(props) {
  const { onChange, value, placeholder, className } = props;

  return (
      <NInput
        className={` !bg-white xxl:!min-w-[373px] ${className}`}
        placeholder={placeholder ?? 'Search'}
        type='text'
        value={value}
        onChange={onChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon className='text-gray-200' />
            </InputAdornment>
          ),
        }}
        {...props}
      />
  );
}

NSearch.propTypes = {
  onChange: PropType.func,
  value: PropType.string,
  placeholder: PropType.string,
  className: PropType.string,
};

NSearch.defaultProps = {
  onChange: undefined,
  value: undefined,
  placeholder: "Search",
  className: "",
};

export default NSearch;
